/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');
const ReactDOM = require('react-dom');
const request = require('superagent');
const scrollIntoView = require('dom-scroll-into-view');
const _ = require('lodash');

const Config = require('../../configs/Config.js');
const AnswerActions = require('../../actions/AnswerActions.jsx');
const AnswerStore = require('../../stores/AnswerStore.jsx');
const QuestionStore = require('../../stores/QuestionStore.jsx');
const PartStore = require('../../stores/PartStore.jsx');
const ProductStore = require('../../stores/ProductStore.jsx');

const SchoolFinder = React.createClass({
  mixins: [
    Reflux.connect(ProductStore, 'productData')
  ],

  getInitialState() {
    let schoolNameQuestion = QuestionStore.getQuestionByName('SchoolName');
    let schoolMascotQuestion = QuestionStore.getQuestionByName('SchoolMascot');
    let schoolColorsQuestion = QuestionStore.getQuestionByName('SchoolColors');

    let schoolNameQuestionId = _.get(schoolNameQuestion, 'id');
    let schoolMascotQuestionId = _.get(schoolMascotQuestion, 'id');
    let schoolColorsQuestionId = _.get(schoolColorsQuestion, 'id');

    let answers = AnswerStore.fetchAll();
    let schoolName = _.get(answers, [schoolNameQuestionId, 'input']);
    let schoolMascot = _.get(answers, [schoolMascotQuestionId, 'input']);
    let schoolColors = _.get(answers, [schoolColorsQuestionId, 'input']);

    return {
      schoolData: {},
      selectedSchool: {
        school_name: schoolName,
        mascot: schoolMascot,
        colors: schoolColors
      },
      loading: false,
      listVisible: false,
      highlightedSchoolIndex: null,
      inputWidth: 0
    };
  },

  schoolQuestions: {},
  ignoreBlur: false,
  isCollegeProduct: false,

  componentWillMount() {
    let schoolFinderQuestion = QuestionStore.getQuestionByName('SchoolFinder');
    let schoolNameQuestion = QuestionStore.getQuestionByName('SchoolName');
    let schoolCodeQuestion = QuestionStore.getQuestionByName('SchoolCode');
    let schoolMascotQuestion = QuestionStore.getQuestionByName('SchoolMascot');
    let schoolColorsQuestion = QuestionStore.getQuestionByName('SchoolColors');
    let schoolSmiQuestion = QuestionStore.getQuestionByName('SchoolSmi');

    this.isCollegeProduct = _.get(this.state.productData, 'metadata.SchoolFinderSchoolType') === 'c';

    const mascotQuestions = _.map(QuestionStore.getQuestionsByMetadataKeyName('GetAnswerFromSchoolMascot'), (question) => {
      return {
        question: question,
        parts: PartStore.fetchPartsForQuestion(question.id)
      };
    });

    this.schoolQuestions = {
      SchoolFinder: {
        question: schoolFinderQuestion,
        part: PartStore.fetchPartsForQuestion(_.get(schoolFinderQuestion, 'id'))[0]
      },
      SchoolName: {
        question: schoolNameQuestion,
        part: PartStore.fetchPartsForQuestion(_.get(schoolNameQuestion, 'id'))[0]
      },
      SchoolCode: {
        question: schoolCodeQuestion,
        part: PartStore.fetchPartsForQuestion(_.get(schoolCodeQuestion, 'id'))[0]
      },
      SchoolMascot: {
        question: schoolMascotQuestion,
        part: PartStore.fetchPartsForQuestion(_.get(schoolMascotQuestion, 'id'))[0]
      },
      SchoolColors: {
        question: schoolColorsQuestion,
        part: PartStore.fetchPartsForQuestion(_.get(schoolColorsQuestion, 'id'))[0]
      },
      SchoolSmi: {
        question: schoolSmiQuestion,
        part: PartStore.fetchPartsForQuestion(_.get(schoolSmiQuestion, 'id'))[0]
      },
      MascotQuestions: mascotQuestions
    };
  },

  componentDidMount() {
    this.setState({ inputWidth: ReactDOM.findDOMNode(this.refs.schoolFinderInput).offsetWidth });
    window.addEventListener('resize', this.handleResize);
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  handleResize() {
    this.setState({ inputWidth: ReactDOM.findDOMNode(this.refs.schoolFinderInput).offsetWidth });
  },

  searchTimer: null,

  updateSearchText(e) {
    let searchText = e.target.value;

    if (this.searchTimer !== null) {
      clearTimeout(this.searchTimer);
    }

    if (searchText.length > 2) {
      this.setState({ loading: true });

      this.searchTimer = setTimeout(() => {
        this.getSchoolData(searchText);
      }, 500);
    } else {
      this.reset();
    }
  },

  getSchoolData(searchText) {
    let loadSchoolData = _.get(Config, 'api.loadSchoolData');
    if (!loadSchoolData) {
      throw new Error('No URL found for Schoolfinder');
    }
    let sfSchoolType = _.get(this.state.productData, 'metadata.SchoolFinderSchoolType');
    loadSchoolData = sfSchoolType ? loadSchoolData + sfSchoolType : loadSchoolData + 'hs';

    request
      .get(loadSchoolData + '/' + searchText)
      .end((err, res) => {
        if (typeof res.body === 'object' && res.body !== null) {
          this.setState({
            schoolData: res.body,
            loading: false,
            listVisible: true,
            highlightedSchoolIndex: res.body.schools.length > 0 ? 0 : null
          });
          ReactDOM.findDOMNode(this.refs.schoolFinderList).scrollTop = 0;
        } else {
          this.reset();
          throw new Error('Error retrieving school data.');
        }
      });
  },

  reset() {
    this.setState({
      schoolData: {},
      loading: false,
      listVisible: false,
      highlightedSchoolIndex: null
    });
  },

  handleKeydown(e) {
    let keyCodes = Config.keyCodes;

    if (e.keyCode === keyCodes.ENTER || e.keyCode === keyCodes.UP || e.keyCode === keyCodes.DOWN || e.keyCode === keyCodes.ESC) {
      // prevent default behavior of up/down keys on input field that moves the cursor
      e.preventDefault();

      let currentIndex = this.state.highlightedSchoolIndex;
      let schoolFinderInput = ReactDOM.findDOMNode(this.refs.schoolFinderInput);

      switch (e.keyCode) {
        case keyCodes.ENTER:
          if (this.state.highlightedSchoolIndex !== null) {
            this.selectSchool(currentIndex);
          }
          break;
        case keyCodes.UP:
          if (currentIndex !== null) {
            if (currentIndex === 0) {
              this.setState({ highlightedSchoolIndex: null });
            } else {
              this.setState({ highlightedSchoolIndex: currentIndex - 1, listVisible: true }, () => {
                this.maybeScrollItemIntoView(currentIndex - 1);
              });
            }
          }
          break;
        case keyCodes.DOWN:
          if (this.state.schoolData.schools && this.state.schoolData.schools.length > 0) {
            if (currentIndex === null) {
              this.setState({ highlightedSchoolIndex: 0, listVisible: true }, () => {
                this.maybeScrollItemIntoView(0);
              });
            } else if (currentIndex !== this.state.schoolData.schools.length - 1) {
              this.setState({ highlightedSchoolIndex: currentIndex + 1, listVisible: true }, () => {
                this.maybeScrollItemIntoView(currentIndex + 1);
              });
            }
          }
          break;
        case keyCodes.ESC:
          this.setState({
            highlightedSchoolIndex: null,
            listVisible: false
          });
          schoolFinderInput.value = '';
          break;
      }
    }
  },

  maybeScrollItemIntoView(i) {
    let itemNode = ReactDOM.findDOMNode(this.refs['schoolFinderListItem-' + i]);
    let listNode = ReactDOM.findDOMNode(this.refs.schoolFinderList);
    scrollIntoView(itemNode, listNode, { onlyScrollIfNeeded: true });
  },

  highlightSchool(i) {
    this.setState({ highlightedSchoolIndex: i });
  },

  getSchoolMascot(school) {
    let schoolFinderQuestion = this.schoolQuestions.SchoolFinder.question;
    let vendor = _.get(schoolFinderQuestion, 'metadata.Vendor');
    if (!vendor) {
      return null;
    }

    vendor = vendor.toLowerCase();

    let mascot = _.get(school, `${vendor}_mascot`);

    return mascot || null;
  },

  selectSchool(i) {
    let school = this.state.schoolData.schools[i];
    ReactDOM.findDOMNode(this.refs.schoolFinderInput).value = school.school_name;

    if (Config.analytics.enableTracking) {
      const trackingTarget = _.get(window, Config.analytics.eventTrackingTarget);

      if (trackingTarget && typeof trackingTarget === 'function') {
        const event = 'uc_answer';
        const category = _.get(Config, 'analytics.eventCategory');
        const action = 'School Selection';
        const productName = ProductStore.getProductName();
        const label = `${productName}: SchoolFinder: ${school.school_name}`;

        trackingTarget(event, category, action, label);
      }
    }

    let answerData = [
      { question: this.schoolQuestions.SchoolFinder.question, part: this.schoolQuestions.SchoolFinder.part, input: school.school_name, valid: true },
      { question: this.schoolQuestions.SchoolName.question, part: this.schoolQuestions.SchoolName.part, input: school.school_name, valid: true },
      { question: this.schoolQuestions.SchoolCode.question, part: this.schoolQuestions.SchoolCode.part, input: school.school_code, valid: true },
      { question: this.schoolQuestions.SchoolMascot.question, part: this.schoolQuestions.SchoolMascot.part, input: school.mascot, valid: true },
      { question: this.schoolQuestions.SchoolColors.question, part: this.schoolQuestions.SchoolColors.part, input: school.colors, valid: true },
      { question: this.schoolQuestions.SchoolSmi.question, part: this.schoolQuestions.SchoolSmi.part, input: school.smi, valid: true }
    ];

    const schoolMascot = this.getSchoolMascot(school);

    // go over all questions that should be automatically answered based on returned school mascot and push answers accordingly
    _.each(this.schoolQuestions.MascotQuestions, (mascotQuestion) => {
      const mascotPart = _.find(mascotQuestion.parts, part => {
        return _.get(part, 'metadata.DefaultMascotImage') === schoolMascot;
      });

      if (mascotPart) {
        answerData.push({
          question: mascotQuestion.question,
          part: mascotPart,
          valid: true
        });
      }
    });

    this.setState({
      selectedSchool: school,
      listVisible: false
    });

    AnswerActions.batchUpdate(answerData);
  },

  showList() {
    this.setState({ listVisible: true });
  },

  hideList() {
    this.setState({ listVisible: false });
  },

  render() {
    let schools = this.state.schoolData.success ? this.state.schoolData.schools : [];
    let schoolMascot = this.state.selectedSchool.mascot ? <p><b>Mascot:</b> {this.state.selectedSchool.mascot}</p> : null;
    let schoolColors = this.state.selectedSchool.colors ? <p><b>Colors:</b> {this.state.selectedSchool.colors}</p> : null;
    let isSignet = _.get(Config, 'loaderStrategy') == 'signet';

    return (
      <div className="uc-control uc-schoolfinder" onTouchStart={() => { this.ignoreBlur = true }}>
        <div className="uc-loading-spinner fa fa-spinner" style={{ display: this.state.loading === true ? 'block' : 'none' }}> </div>

        <input
          aria-label="School Finder"
          type="text"
          ref="schoolFinderInput"
          tabIndex={this.props.tabIndex}
          defaultValue={this.state.selectedSchool.school_name ? this.state.selectedSchool.school_name : ''}
          placeholder="Start typing to search schools"
          onChange={this.updateSearchText}
          onKeyDown={this.handleKeydown}
          onClick={this.showList}
          onFocus={this.showList}
          onBlur={this.ignoreBlur ? null : this.hideList}
          maxLength="100" />

        <ul
          className="uc-schoolfinder-list"
          ref="schoolFinderList"
          style={{
            display: this.state.listVisible === true && schools.length > 0 ? 'block' : 'none',
            width: this.state.inputWidth
          }}>
          {
            _.map(schools, (school, i) => {
              return (
                <li key={i}
                  className={this.state.highlightedSchoolIndex === i ? 'uc-highlighted' : ''}
                  ref={'schoolFinderListItem-' + i}
                  onMouseEnter={this.highlightSchool.bind(null, i)}
                  onClick={this.selectSchool.bind(null, i)}
                  onMouseDown={e => e.preventDefault()}>
                  <div className="uc-school-name">{school.school_name}</div>
                  <div className="uc-school-location">{school.city + ', ' + school.state}</div>
                </li>
              );
            })
          }
        </ul>

        {schoolMascot}
        {schoolColors}

        { !isSignet ? (
        <p className="uc-control-text">
          {
          'Please note that' +
	        this.isCollegeProduct ? ' all' : '' +
	        ' Colleges and Universities are not available.'
          }
        </p>
        ) : null
        }
      </div>
    );
  }
});

module.exports = SchoolFinder;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/SchoolFinder.jsx